import { injectIntl, IntlShape } from 'react-intl';
import { useState } from 'react';
import { get, isEmpty } from 'lodash';
import { Grid, TextField } from '@material-ui/core';
import { translate } from 'containers/services/translate';
import { Dialog } from 'containers/CourtManagerLegalProceedings/Provision/Regulation/styled-components';
import messages from 'containers/CourtManagerLegalProceedings/Provision/Regulation/messages';

import {
  formatDate,
  getJudgementOnMeritsByJudgementDates,
  getRisks,
} from 'containers/CourtManagerLegalProceedings/Provision/Regulation/utils';
import SahamAccordion from 'components/SahamAccordion';

export interface RiskDialogProps {
  intl: IntlShape;
  riskRecap: any;
  activeStep: any;
  setActiveStep: any;
  setOpenDialog: any;
  openDialog: boolean;
  judgementOnMeritsByVictims: any;
  judgementOnMeritsByVehicles: any;
  setShowRegulationJudgement: Function;
  isBasicManagementRegulation?: boolean;
}

export const RiskDialog: React.FC<RiskDialogProps> = ({
  ...props
}): JSX.Element => {
  const { rcCorpo, rcMaterial } = getRisks(props.riskRecap);
  const [expanded, setExpanded] = useState(true);
  const handleChangeExpanded = (
    event: React.ChangeEvent<{}>,
    expanded: boolean,
  ) => {
    setExpanded(expanded);
  };
  const onClose = () => {
    return props.setOpenDialog(false);
  };
  const validateDialog = () => {
    props.setOpenDialog(false);
    props.setShowRegulationJudgement(true);
    props.setActiveStep(props.activeStep + 1);
  };
  const {
    appealOnMerit: appealOnMeritsByVehicles,
    judgementOnMerit: judgementOnMeritsByVehicles,
  } = getJudgementOnMeritsByJudgementDates(
    props.judgementOnMeritsByVehicles,
    get(rcMaterial, 'regulationInfo', {}),
  );

  const {
    appealOnMerit: appealOnMeritsByVictims,
    judgementOnMerit: judgementOnMeritsByVictims,
  } = getJudgementOnMeritsByJudgementDates(
    props.judgementOnMeritsByVictims,
    get(rcCorpo, 'regulationInfo', {}),
  );

  return (
    <Dialog
      open={props.openDialog}
      handleClose={onClose}
      handleValidate={validateDialog}
      title={translate(messages.confirmJudgementOnMerits, props)}
      confirmTitle={translate(messages.confirm, props)}
      cancelTitle={translate(messages.cancelDialog, props)}
    >
      {!isEmpty(rcCorpo) && (
        <SahamAccordion
          key={rcCorpo.regulationId}
          title={`${translate(messages.riskInfo, props)} - ${rcCorpo.riskName}`}
          expanded={expanded}
          onChange={handleChangeExpanded}
        >
          <Grid container spacing={4}>
            {!props.isBasicManagementRegulation && (
              <>
                {isEmpty(appealOnMeritsByVictims) && (
                  <Grid item xs={4}>
                    <TextField
                      value={formatDate(
                        get(
                          judgementOnMeritsByVictims,
                          'jom.judgementDate',
                          '',
                        ),
                      )}
                      className="jom-info"
                      label={translate({ ...messages.judgementDate }, props)}
                    />
                  </Grid>
                )}

                {!isEmpty(appealOnMeritsByVictims) && (
                  <>
                    <Grid item xs={4}>
                      <TextField
                        value={formatDate(
                          get(appealOnMeritsByVictims, 'jom.judgementDate', ''),
                        )}
                        className="jom-info"
                        label={translate({ ...messages.appealDate }, props)}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <TextField
                        value={formatDate(
                          get(
                            judgementOnMeritsByVictims,
                            'jom.judgementDate',
                            '',
                          ),
                        )}
                        className="jom-info"
                        label={translate({ ...messages.judgementDate }, props)}
                      />
                    </Grid>
                  </>
                )}
                <Grid item xs={4}>
                  <TextField
                    value={
                      isEmpty(appealOnMeritsByVictims)
                        ? get(
                            judgementOnMeritsByVictims,
                            'jom.judgementNumber',
                            '',
                          )
                        : get(
                            appealOnMeritsByVictims,
                            'jom.judgementNumber',
                            '',
                          )
                    }
                    className="jom-info"
                    label={translate({ ...messages.courtNumber }, props)}
                  />
                </Grid>
              </>
            )}

            {/* istanbul ignore next */ props.isBasicManagementRegulation && (
              <>
                {!get(rcCorpo.regulationInfo, 'isAppeal', false) && (
                  <Grid item xs={4}>
                    <TextField
                      value={formatDate(
                        get(rcCorpo.regulationInfo, 'judgementDate', ''),
                      )}
                      className="jom-info"
                      label={translate({ ...messages.judgementDate }, props)}
                    />
                  </Grid>
                )}
                {get(rcCorpo.regulationInfo, 'isAppeal', false) && (
                  <>
                    <Grid item xs={4}>
                      <TextField
                        value={formatDate(
                          get(rcCorpo.regulationInfo, 'judgementDate', ''),
                        )}
                        className="jom-info"
                        label={translate({ ...messages.appealDate }, props)}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <TextField
                        value={formatDate(
                          get(rcCorpo.regulationInfo, 'judgementDateJom', ''),
                        )}
                        className="jom-info"
                        label={translate({ ...messages.judgementDate }, props)}
                      />
                    </Grid>
                  </>
                )}
                <Grid item xs={4}>
                  <TextField
                    value={get(rcCorpo.regulationInfo, 'courtNumber', '')}
                    className="jom-info"
                    label={translate({ ...messages.courtNumber }, props)}
                  />
                </Grid>
              </>
            )}
          </Grid>
        </SahamAccordion>
      )}
      {!isEmpty(rcMaterial) && (
        <SahamAccordion
          key={rcMaterial.regulationId}
          title={`${translate(messages.riskInfo, props)} - ${
            rcMaterial.riskName
          }`}
          onChange={handleChangeExpanded}
          expanded={expanded}
        >
          <Grid container spacing={4}>
            {isEmpty(appealOnMeritsByVehicles) && (
              <Grid item xs={4}>
                <TextField
                  className="jom-info"
                  value={formatDate(
                    get(judgementOnMeritsByVehicles, 'jom.judgementDate', ''),
                  )}
                  label={translate({ ...messages.judgementDate }, props)}
                />
              </Grid>
            )}
            {!isEmpty(appealOnMeritsByVehicles) && (
              <>
                <Grid item xs={4}>
                  <TextField
                    className="jom-info"
                    value={formatDate(
                      get(appealOnMeritsByVehicles, 'jom.judgementDate', ''),
                    )}
                    label={translate({ ...messages.appealDate }, props)}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    className="jom-info"
                    value={formatDate(
                      get(judgementOnMeritsByVehicles, 'jom.judgementDate', ''),
                    )}
                    label={translate({ ...messages.judgementDate }, props)}
                  />
                </Grid>
              </>
            )}
            <Grid item xs={4}>
              <TextField
                className="jom-info"
                value={
                  isEmpty(appealOnMeritsByVehicles)
                    ? get(
                        judgementOnMeritsByVehicles,
                        'jom.judgementNumber',
                        '',
                      )
                    : get(appealOnMeritsByVehicles, 'jom.judgementNumber', '')
                }
                label={translate({ ...messages.courtNumber }, props)}
              />
            </Grid>
          </Grid>
        </SahamAccordion>
      )}
    </Dialog>
  );
};

export default injectIntl(RiskDialog);
